<template>
    <div class="toast_no_locations_selected">
        <div class="toast_no_locations_selected_wrap">
            <div class="toast_no_locations_selected_title">
                {{ title }}
            </div>
        </div>
        <div class="toast_no_locations_selected_buttons">
            <button class="toast_no_locations_selected_buttons_button" @click.prevent="clickChoose">
                <span class="toast_no_locations_selected_buttons_button_text">{{
                        __t('O.CHOOSE_WHAT_TO_ENABLE')
                    }}</span>
            </button>
            <button class="toast_no_locations_selected_buttons_button see" @click.prevent="clickTurnOn">
                <spinner_button
                    v-if="isActionProcess"
                    :key="'spinner_button_turn_on_locations'"
                    :color="colorSpinner"
                    :size="'25px'"
                />
                <span v-else class="toast_no_locations_selected_buttons_button_text">{{
                        __t('O.TURN_ON_EVERYTHING')
                    }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import __t from "../../mixins/translate";
import spinner_button from "../loader/SpinnerButton.vue";

export default {
    name: "modal_new_order",
    components: {spinner_button},
    props: {
        toastId: {
            type: [String, Number],
            required: true,
        },
        closeToast: {
            type: Function,
            required: true,
        },
    },
    mixins: [
        __t
    ],
    data() {
        return {
            colorSpinner: '#FFFFFF',
            isActionProcess: false,
        }
    },
    created() {
        EventBus.$on('finish_get_aggregators_locations', this.finishGetAggregatorsLocations);
    },
    beforeUnmount() {
        EventBus.$off('finish_get_aggregators_locations', this.finishGetAggregatorsLocations);
    },
    methods: {
        clickTurnOn() {
            this.isActionProcess = true;
            this.turnLocations();

        },
        clickChoose() {
            window.location.href = "/location/select";
            this.closeToast(this.toastId);
        },
        async turnLocations() {
            await $store.dispatch('aggregators/ACTIVE_AGGREGATORS_DELIVERIES_LIST', {
                onlySelectLocations: false,
                actionName: 'activeAggregatorsList'
            });

            for (const aggregator of $store.state.aggregators.aggregatorsDeliveriesList) {
                await this.addAggregatorLocations(aggregator)
            }
            await $store.dispatch('orders/GET_ORDERS_POOLING', {
                user: this.user,
                setDefaultOrder: false,
                eventSend: true,
                idOrder: null,
                newOrderIn: null,
                actionName: 'getOrdersPooling',
            });
            this.isActionProcess = false;
            this.closeToast(this.toastId);
        },
        async addAggregatorLocations(aggregator) {
            if (aggregator.type_data === 'aggregator') {
                await $store.dispatch('aggregators/AGGREGATOR_LOCATIONS', {
                    aggregatorId: aggregator.id,
                    onlySelectLocations: false,
                    actionName: 'loadAggregatorLocations'
                });
                const restList = $store.state.aggregators.aggregatorLocations.map(item => item.id);
                await $store.dispatch('aggregators/ADD_ACTIVE_LOCATION_LIST', {
                    id: aggregator.id,
                    restList: restList,
                    actionName: 'switchOnAllLocations'
                });
            }
            if (aggregator.type_data === 'delivery') {
                await $store.dispatch('couriers/DELIVERY_LOCATIONS', {
                    deliveryId: aggregator.id,
                    actionName: 'loadDeliveryLocations'
                });
                const restList = $store.state.couriers.deliveryLocations.map(item => item.id);
                await $store.dispatch('couriers/ADD_ACTIVE_LOCATION_LIST', {
                    id: aggregator.id,
                    restList: restList,
                    actionName: 'switchOnAllLocations'
                });
            }
        }
    },
    computed: {
        title() {
            return `${this.__t('O.NO_LOCATIONS_ARE_ENABLED_FOR_ORDER_TRACKING')}`;
        },
    },
}
</script>
